import * as React from 'react';
import Svg, { Path,Rect } from 'react-native-svg';

function EmailIcon(props) {
  return (
    <Svg
      width={props.size || 16}
      height={props.size || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Rect width={42} height={42} rx={4.2} fill={props?.bgColor ?? "#F3F5FC"} />
      <Path
        d="M2.333 13.333a.96.96 0 01-.7-.3.96.96 0 01-.3-.7V3.667c0-.267.1-.5.3-.7.2-.2.434-.3.7-.3h11.334c.267 0 .5.1.7.3.2.2.3.433.3.7v8.666c0 .267-.1.5-.3.7-.2.2-.434.3-.7.3H2.333zm11.334-8.75l-5.4 3.534a2.357 2.357 0 01-.125.058A.36.36 0 018 8.2a.36.36 0 01-.141-.025 2.354 2.354 0 01-.125-.059l-5.4-3.533v7.75h11.333v-7.75zM8 7.3l5.6-3.633H2.417L8 7.3zM2.333 4.583V4.7 4.04v.009-.383.383-.017.667-.117 7.75-7.75z"
        fill={props.color || '#1434CB'}
      />
    </Svg>
  );
}

export default EmailIcon;
